/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

(function() {
  'use strict';

  angular
    .module('SOGo.Common')
    .directive('sgRippleClick', sgRippleClick);

  /*
   * sgCheckmark - A checkmark to be used in a mdMenuItem
   * @memberof SOGo.Common
   * @restrict element
   *
   * @example:

     <md-menu>
       <md-button class="md-icon-button" aria-label="Sort"
                  ng-click="$mdOpenMenu()">
         <md-icon>sort</md-icon>
       </md-button>
       <md-menu-content>
         <md-menu-item>
           <sg-checkmark
               aria-label="Descending Order"
               ng-model="ctrl.asc"
               ng-click="ctrl.filter()"
               sg-true-value="0"
               sg-false-value="1">Descending Order</sg-checkmark>
         </md-menu-item>            
       </md-menu-content>
     </md-menu>
  */
  sgRippleClick.$inject = ['$parse', '$mdAria', '$document', '$mdUtil'];
  function sgRippleClick($parse, $mdAria, $document, $mdUtil) {

    return {
      restrict: 'A',
      compile: compile
    };

    function compile(tElement, tAttrs) {

      return function postLink(scope, element, attr, ngModelCtrl) {
        var ripple, content, container, containerId;

        // Lookup container element
        containerId = element.attr('sg-ripple-click');
        container = element[0].parentNode;
        while (container && container.id != containerId) {
          container = container.parentNode;
        }

        // Create ripple layer if necessary
        ripple = container.querySelector('.sg-ripple');
        if (ripple) {
          ripple = angular.element(ripple);
        }
        else {
          ripple = angular.element('<div class="sg-ripple md-default-theme md-bg"></div>');
          container.appendChild(ripple[0]);
        }

        // Hide ripple content on initialization
        content = container.querySelector('.sg-ripple-content');
        if (!content.classList.contains('ng-hide'))
          content.classList.add('ng-hide');

        // Register listener
        element.on('click', listener);
        
        function listener(event) {
          if (element[0].hasAttribute('disabled')) {
            return;
          }

          if (content.classList.contains('ng-hide')) {
            // Show ripple
            angular.element(container).css({
              'overflow': 'hidden'
            });
            content.classList.remove('ng-hide');
            ripple.css({
	      'top': (event.pageY - container.offsetTop) + 'px',
	      'left': (event.pageX - container.offsetLeft) + 'px',
	      'width': '400vw',
	      'height': '400vw'
	    });
          }
          else {
            // Hide ripple
            content.classList.add('ng-hide');
            ripple.css({
              'top': (event.pageY - container.offsetTop) + 'px',
	      'left': (event.pageX - container.offsetLeft) + 'px',
              'height': '0px',
              'width': '0px'
            });
          }
        }
      };
    }
  }
})();
